import { VISIT } from "../constants";

const initialState = {
  visits: [],
  patientId: null,
  isLoadingGet: false,
  isLoadingCreate: false,
  isLoadingValidate: false,
  error: null,
};

const visitReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case VISIT.GET_VISITS:
      return { ...state, isLoadingGet: true };
    case VISIT.GET_VISITS_SUCCESS:
      return { ...state, isLoadingGet: false, visits: action.payload, error: null };
    case VISIT.GET_VISITS_FAILURE:
      return { ...state, isLoadingGet: false, error: action.payload };
    case VISIT.CREATE_VISIT:
      return { ...state, isLoadingCreate: true };
    case VISIT.CREATE_VISIT_SUCCESS:
      return { ...state, isLoadingCreate: false, error: null };
    case VISIT.CREATE_VISIT_FAILURE:
      return { ...state, isLoadingCreate: false, error: action.payload };
    case VISIT.VALIDATE_VISIT:
      return { ...state, isLoadingValidate: true };
    case VISIT.VALIDATE_VISIT_SUCCESS:
      return { ...state, isLoadingValidate: false, error: null };
    case VISIT.VALIDATE_VISIT_FAILURE:
      return { ...state, isLoadingValidate: false, error: action.payload };
    case VISIT.DELETE_VISIT_SUCCESS:
      return { ...state, error: null };
    case VISIT.SET_PATIENT_ID:
      return { ...state, patientId: action.payload };
    case VISIT.CLEAN_VISIT:
      return { ...initialState };
    default:
      return state;
  }
};

export default visitReducer;
